<template>
    <div class="container">
		<div class="title">
			<span>余杭区百行百匠赛</span>
			<span class="sub-tit">服装缝制实战精英大赛</span>
		</div>
        <div class="content">
            为响应余杭3个全域建设，建立基础工人及工厂等级判定，建立核心产业工人资料库，验证建立小团队快返标准可复制模型。打造数字时尚新高地的号召，同时吸引服装产业优质专业制造人才，有效提高优秀人才进驻余杭的意愿，亿尚智能在各界领导单位的指导下，特举办本次服装技工大赛活动。
        </div>
        <div class="flag-title">
            百行百匠  赢万元奖金！
        </div>
        <div class="btns">
            <span class="agree" @click="agree(1)">接 受 邀 请</span>
            <div class="reject clearfix">
                <span class="reject1" @click="agree(2)">拒绝邀请</span>
                <span class="reject2" @click="toLink">我已受邀</span>
            </div>
        </div>
        <div class="tips">
            提示：邀约有效期7天
        </div>
	</div>
</template>

<script>
import { agreeOrRefuse } from '@/api/index'
export default {
    data() {
        return {
            code: '',  // 756271
        }
    },
    watch: {
		$route: {
			handler: function(route) {
				this.code = route.query && route.query.code
			},
			immediate: true
		}
	},
    methods: {
        agree(index) {
            let content = ''
            if (index == 1) {content = '您确定接受邀请吗？'}
            if (index == 2) {content = '您确定拒绝邀请吗？'}
            this.$createDialog({
                type: 'confirm',
                title: '提示',
                content: content,
                confirmBtn: {
                    text: '确定',
                    active: true,
                    disabled: false,
                    href: 'javascript:;'
                },
                cancelBtn: {
                    text: '取消',
                    active: false,
                    disabled: false,
                    href: 'javascript:;'
                },
                onConfirm: () => {
                    this.submit(index);
                },
                onCancel: () => {
                    // ...
                }
            }).show()

        },
        submit(index) {
            const loading = this.$createToast({
                time: 0,
                txt: '正在提交...',
                mask: true
            })
            loading.show()
            agreeOrRefuse({userInviteCode: this.code, userDeviceInfo: navigator.userAgent, type: index}).then(res => {
                console.log(res)
                loading.hide();
                if (index == 1) {
                    if (res.errorCode == 200) {
                        this.$store.dispatch('Login', {
                            token: res.data.token,
                            userId: res.data.userId
                        })
                        this.$createToast({
							txt: '接受成功',
							type: 'txt'
                        }).show()
                        setTimeout(() => {
                            this.$router.push('/certificate')
                        }, 1000)
                    } else if (res.errorCode == -10999) {
                        this.$createToast({
							txt: '您已操作，请勿重复操作',
							type: 'txt'
                        }).show()
                        setTimeout(() => {
                            this.$router.push('/index')
                        }, 1000)
                    } else {
                        this.$createToast({
							txt: res.errorMsg,
							type: 'txt'
                        }).show()
                    }
                }
                if (index == 2) {
                    if (res.errorCode == 200) {
                        this.$createToast({
							txt: '拒绝成功',
							type: 'txt'
                        }).show()
                        setTimeout(() => {
                            this.$router.push('/index')
                        }, 1000)
                    } else if (res.errorCode == -10888) {
                        this.$createToast({
							txt: '您已操作，请勿重复操作',
							type: 'txt'
                        }).show()
                        setTimeout(() => {
                            this.$router.push('/index')
                        }, 1000)
                    }  else {
                        this.$createToast({
							txt: res.errorMsg,
							type: 'txt'
                        }).show()
                    }
                }
            }).catch(err => {
                loading.hide();
                this.$createToast({
                    txt: '网络异常',
                    type: 'txt'
                }).show()
            })
        },
        toLink() {
            this.$router.push('/certificate')
        }
    }
}
</script>


<style lang="scss" scoped>
.container {
	width: 100%;
	min-height: 100vh;
	background: #242f3c url(../assets/bg.png) no-repeat left bottom/100%;
	overflow: hidden;
	max-width: 768px;
	margin: 0 auto;
	position: relative;
}
.title {
	padding: 3.4rem 0.2rem 0;
	text-align: center;
	font-size: 0.4rem;
	letter-spacing: 0.1rem;
	color: #fff;
	line-height: 2;
	background: url(../assets/icon_success.png) no-repeat center 1.0rem/ 5.74rem 2.41rem;
}

.title .sub-tit {
    display: block;
	padding: 0.1rem 0.3rem 0.4rem;
	line-height: 1.5;
	border-radius: 0.1rem;
	color: #fff;
	font-size: 0.32rem;
	border: none;
	letter-spacing: 0.04rem;
}
.content {
    font-size: 0.28rem;
    color: #a3a3a3;
    padding: 0 0.4rem;
    line-height: 1.8;
    text-align: justify;
}
.flag-title {
    padding: 0.5rem 0; 
    font-size: 0.5rem;
    color: #de7a31;
    text-align: center;
}
.btns {
    text-align: center;
}
.btns .agree {
    display: inline-block;
    width: 4.2rem;
    height: 0.8rem;
    line-height: 0.8rem;
    background: #de7a31;
    color: #fff;
    font-weight: bold;
    border-radius: 0.1rem;
}
.btns .reject {
    display: inline-block;
    width: 4.2rem;
    height: 0.8rem;
    line-height: 0.8rem;
    color: #fff;
    margin-top: 0.2rem;
}
.btns .reject1 {
    float: left;
}
.btns .reject2 {
    float: right;
}
.tips {
    padding: 0.2rem 0 0.5rem;
    color: #a3a3a3;
    font-size: 0.28rem;
    text-align: center;
}
</style>

